import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import Button from '@material-ui/core/Button';
import { CircularProgress } from '@material-ui/core';

import { useState } from 'react';

import "@fontsource/mulish"; // Defaults to weight 400.


const useStyles = makeStyles(theme => ({   
    outerRow: {        
        fontFamily:'Mulish', 
        fontWeight: '200',
        // backgroundColor: 'white',
        display:'flex',
        flexDirection: 'column',
        justifyContent:'flex-start',
        alignItems: 'flex-start',         
        paddingLeft: '5vw',  
        paddingTop: '2vh',
        paddingBottom: '2vh'               
    },
    titleText: {
        
        fontSize: '12pt', 
        marginBottom: '2vh'
 
    },
    promptText: {
        fontSize: '8pt', 

    },
    inputRow: {
        display:'flex',
        flexDirection: 'row',
        justifyContent:'space-between',
        alignItems: 'center',       

    },
    input: {
        borderRadius: '3pt',
        borderWidth : '.5pt',
        height: '4vh',
       
    },
    searchButton: {
        borderRadius: '3pt',
        borderWidth : '.5pt',
        height: '3vh',
        marginTop: '4%',
        backgroundColor: '#5CD6D2',
        color: 'white',
        marginTop: '1%',
        marginLeft: '10%',
        padding: '7px',
        paddingLeft: '12px',
        paddingRight: '12px',

        
    },
    primaryButton: {
        backgroundColor: '#5CD6D2',
        color: 'white',      
        fontWeight: 'bold',
        marginLeft: '2em',
        '&:hover': {
          backgroundColor: '#FFC24C',
          color: 'black',
        },
        // 
      }, 
      spinnerFlex: {
        marginLeft: '.5em'
         

    },


    }));

   





const SearchBox = (props) => {

    const appVersion = 'v. 0.2.1'

    const classes = useStyles();

    const [searchValue, setSearchValue] = useState();

   
    const onClick = (e) => { 
        console.log("Searchbox sent: ", searchValue);
        props.onSearch(searchValue);                
    }

    const onChange = (text) => {
        
        setSearchValue(text);

        if (text=='#version') {           
            alert(appVersion);
        }
    }
   

    return(
        <div className={classes.outerRow}>
            
            <div className={classes.titleText}> Finn informasjon om kjøretøy </div>

            <div className={classes.promptText}> Søk etter registreringsnummer </div>

            <div className={classes.inputRow}>
                <input type="text" className={classes.input} onChange={e => onChange(e.target.value)}/> 
               {/*  <input type="text" className={classes.input} onChange={e => setSearchValue(e.target.value)}/>  */}

                
                <Button  variant="contained" color="primary" className={classes.primaryButton} onClick={onClick} disabled={props.inProgress} >
                    Søk                    
                </Button>   

                
                {props.inProgress &&
                    <div className={classes.spinnerFlex}>
                        <CircularProgress size='1.5em'/>
                    </div>
                }
                                
            </div>

        </div>
    )
};

export default SearchBox;